import React,{useEffect,useState,useContext} from "react";
import { ethers } from "ethers";
import { Addr } from "../App";

import { Link } from "react-router-dom";



export default function Nav() {
  const [defaultAccount,setDefaultAccount]=useState()

  const acc = useContext(Addr)
  
  return (
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
      <Link to="/" class="navbar-brand">
        Circle Bet{" "}
      </Link>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarNavAltMarkup"
        aria-controls="navbarNavAltMarkup"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
        <div class="navbar-nav">
          <Link to={"/"} class="nav-item nav-link active">
            Home
          </Link>
          <Link to={"/wallet"} class="nav-item nav-link active">
            {" "}
            Wallet{" "}
          </Link>
          <Link to={"/store"} class="nav-item nav-link active">
            {" "}
            Store{" "}
          </Link>
          <Link to={"/betHistory"} class="nav-item nav-link active">
            {" "}
            Bet History
          </Link>
          {acc && acc.addr == "0x75c1853b3502450923decc79dff8a44d6eeb9ff2" &&
            <Link to={"/admin"} class="nav-item nav-link active">
          
            Admin
          </Link>
          }
          
        </div>
      </div>
    </nav>
  );
}
